import {
  WSFlexBox,
  WSIcon,
  WSList,
  WSPanel,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  BackgroundCheck,
  BackgroundCheckPackageSearchesInner
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { WSQueries } from "../../../../../../query/WSQuery";
import { EmptyComponent } from "../../../../../../shared/components/EmptyComponent";
import { queriesBackgroundCheckPackages } from "../../../../../../v3/query/queriesBackgroundCheckPackages";

const ListItem: React.FC<{ label: string }> = ({ label }) => {
  return (
    <WSFlexBox.CenterY alignItems="flex-start" wrap="nowrap">
      <WSIcon color="gray500" mr="M" name="shield-check" size="S" />
      <WSText.ParagraphSm>{label}</WSText.ParagraphSm>
    </WSFlexBox.CenterY>
  );
};

export const ReportsInfoWidgetContent: React.FC<{
  searches?: BackgroundCheckPackageSearchesInner[];
}> = ({ searches }) => {
  return searches ? (
    <WSList gap="S">
      <WSSectionToolbar title="Reports" />
      <WSPanel>
        <WSList gap="M">
          {searches.map(({ title }, index) => (
            <ListItem key={(title ?? "") + index} label={title ?? ""} />
          ))}
        </WSList>
      </WSPanel>
    </WSList>
  ) : null;
};

export const ReportsInfoWidget: React.FC<{
  backgroundCheck: BackgroundCheck;
}> = ({ backgroundCheck }) => {
  const queryBackgroundCheckPackage =
    queriesBackgroundCheckPackages.getBackgroundCheckPackage.useQuery(
      { backgroundCheckPackageId: backgroundCheck.packageId! },
      { enabled: !!backgroundCheck.packageId }
    );

  return (
    <WSQueries
      queries={{ queryBackgroundCheckPackage }}
      renderErrors={EmptyComponent}
      renderLoader={EmptyComponent}
    >
      {({ queryBackgroundCheckPackageData }) => {
        return (
          <ReportsInfoWidgetContent
            searches={queryBackgroundCheckPackageData.searches}
          />
        );
      }}
    </WSQueries>
  );
};
